import {userService} from '../_services';
import router from "../router/index";

const user = JSON.parse(localStorage.getItem('user'));

const state = user
  ? {status: {loggedId: true}, user}
  : {status: {}, user: null};

const actions = {
  login({dispatch, commit}, {username, password}) {
    commit('loginRequest', {username});

    userService.login(username, password)
      .then(
        user => {
          commit('loginSuccess', user);
          //this.$router.push("/")
          router.push('/');
        },
        error => {
          commit('loginFailure', error);
          dispatch('alert/error', error, {root: true});
        }
      );
  },

  logout({commit}) {
    userService.logout();
    commit('logout');
  }

};

const mutations = {
  loginRequest(state, user) {
    state.status = {loggingIn: true};
    state.user = user
  },
  loginSuccess(state, user) {
    state.status = {loggedIn: true};
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  }
}

export const account = {
  namespaced: true,
  state,
  actions,
  mutations
}
